import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';

import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { Utils } from '@src/utils/util';
import { ReportsAuditComponent } from './reports-audit.component';
import { ReportFilterComponent } from './reports-audit-filter/reports-audit-filter.component';
import { ReportDataAuditComponent } from './reports-audit-data/reports-audit-data.component'; 
import {HttpClientModule} from '@angular/common/http';

@NgModule({
    imports: [SharedModule, MatTableModule, MatSortModule, MatDatepickerModule, MatInputModule, MatNativeDateModule , HttpClientModule],
    declarations: [ReportsAuditComponent,ReportDataAuditComponent,ReportFilterComponent],
    entryComponents: [ReportsAuditComponent],
    exports: [ReportsAuditComponent],
    providers: [MatDatepickerModule, MatNativeDateModule, Utils]
})
export class RepoersAuditDetailsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/reports/report-details-an7/reports-audit.component.module.ts